import { useMemo } from 'react';
import type { MemberSearchQuery_members } from '@frontend/app/queries/types/MemberSearchQuery';
import type { ISocialAccount } from '@components';
import { memberPostPerformanceAdapter } from '@/app/containers/Projects/ProjectsPage/ProspectsList/adapters/member-post-performance-adapter';

export interface PostPerformanceData {
  avgImpressionsPerPost: string;
  postImpressionRatio: string;
  storiesImpressionRatio: string;
  commentSentiment: string;
  avgSavesPerPost: string;
  likesPerPost: string;
  avgCommentsPerPost: string;
  likesToCommentsRatio: string;
}

export interface PostPerformanceSectionProps {
  isLoading: boolean;
  data: PostPerformanceData;
}

export const usePostPerformanceProps = (
  isFetchingSocialData: boolean,
  member: MemberSearchQuery_members | null,
  socialData?: ISocialAccount | null
): PostPerformanceSectionProps => {
  const adaptedData = useMemo(() => {
    if (!socialData || !member) {
      return {
        avgImpressionsPerPost: '--',
        postImpressionRatio: '--',
        storiesImpressionRatio: '--',
        commentSentiment: '--',
        avgSavesPerPost: '--',
        likesPerPost: '--',
        avgCommentsPerPost: '--',
        likesToCommentsRatio: '--'
      };
    }
    return memberPostPerformanceAdapter(socialData);
  }, [socialData, member]);

  return {
    isLoading: isFetchingSocialData,
    data: adaptedData
  };
};
